import alt from 'components/Dispatcher';
import flatMap from 'lodash/flatMap';
import DepartmentSource from 'sources/DepartmentSource';

class DepartmentFormActions {
  constructor() {
    const crudActions = flatMap(['commitStagingField'], op =>
      ['Success', 'Error', 'Loading'].map(status => op + status)
    );
    this.generateActions(
      'editDepartment',
      'openCreateDialog',
      'closeCreateDialog',
      'validateDepartment',
      'fieldTouched',
      'requestSubmit',
      'editStagingDepartment',
      'toggleEditField',
      'discardStagingField',
      'toggleHelp',
      ...crudActions
    );
  }

  commitStagingField(field, updatedDepartment) {
    return dispatch => {
      dispatch(field);
      DepartmentSource.updateDepartment(updatedDepartment).then(
        department => {
          this.commitStagingFieldSuccess(field, department);
        },
        () => this.commitStagingFieldError(field)
      );
    };
  }
}

export default alt.createActions(DepartmentFormActions);
